// Entry point for the build script in your package.json

import '@hotwired/turbo-rails';
import { StreamActions } from "@hotwired/turbo"
import { createConsumer } from '@rails/actioncable';
import TurboPower from 'turbo_power'
import 'apexcharts';
import 'cally';

// Import and register all controllers
import './controllers';

const App = {};
App.cable = createConsumer();

window.App = App;

TurboPower.initialize(StreamActions)

StreamActions.open_modal = function () {
  const modal_id = this.getAttribute("modal_id")
  const modal = document.querySelector(modal_id)
  modal.classList.remove("hidden")
  modal.showModal()
}

StreamActions.upsert_modal = function () {
  const modal_id = this.getAttribute("modal_id")
  const modal_html = this.getAttribute("html")
  const dialogs_container = document.getElementById("dialogs-container")
  // existing modals on tha page
  let dialogs = dialogs_container.querySelectorAll("dialog")

  // this is a new dialog we receive from the server
  let newModalContainer = document.createElement("div")
  newModalContainer.innerHTML = modal_html
  let newModal = newModalContainer.querySelector("dialog")
  let newModalBox = newModalContainer.querySelector(".modal-box")

  // we want to replace the existing modal with the new one
  dialogs.forEach(dialog => {
    // replace body of the existing modal with the new modal
    // with a new modal box
    let existingModalBox = dialog.querySelector(".modal-box")
    if (existingModalBox) {
      // also replace all attributes of the existing modal with the new modal (like ID, class, etc)
      dialog.getAttributeNames().forEach(attribute => {
        dialog.removeAttribute(attribute)
      })

      // copy html attributes from newModal to dialog
      newModal.getAttributeNames().forEach(attribute => {
        dialog.setAttribute(attribute, newModal.getAttribute(attribute))
      })

      existingModalBox.replaceWith(newModalBox)
    }
    return
  })

  // if no dialogs are found, we need to append the new modal to the dialogs container
  if (dialogs.length === 0) {
    dialogs_container.appendChild(newModalContainer)
  }

  let modal = document.querySelector(modal_id)
  if (modal) {
    modal.classList.remove("hidden")

    // we always open the modal if not already open
    if (!modal.open) {
      modal.showModal()
    }
  }
}

StreamActions.close_modal = function () {
  document.querySelectorAll("dialog").forEach(dialog => {
    dialog.close()
  })
}

StreamActions.highlight_current_conversation = function () {
  document.querySelectorAll(".sidebar-conversation-item").forEach(item => {
    item.classList.remove("highlighted-conversation");
  });

  const chat_messages = document.getElementById("chat-messages");
  if (chat_messages) {
    const conversationId = chat_messages.getAttribute("data-chat-conversation-id-value");
    const conversationItem = document.querySelector(`#sidebar-conversation-${conversationId} .sidebar-conversation-item`);
    if (conversationItem) {
      conversationItem.classList.add("highlighted-conversation");
    }
  }
}

StreamActions.update_unread_notifications_count = function () {
  const unreadNotificationsCounts = document.querySelectorAll(".unread-notifications-count");
  const notificationsCount = parseInt(this.getAttribute("value")) || 0;
  const conversationId = this.getAttribute("conversation_id");

  if (conversationId) {
    const conversationItem = document.querySelector(
      `#chat-messages[data-chat-conversation-id-value="${conversationId}"]`
    );
    if (conversationItem) {
      return;
    }
  }

  if (notificationsCount > 0) {
    unreadNotificationsCounts.forEach(count => {
      count.textContent = notificationsCount;
      count.classList.remove("hidden");
    });
  } else {
    unreadNotificationsCounts.forEach(count => {
      count.textContent = "";
      count.classList.add("hidden");
    });
  }
}

StreamActions.payment_successful = function () {
  window.dispatchEvent(new Event("payment_successful", { bubbles: true }))
}
